export function traverseTree<T extends Record<string, any>>(
  data: any[],
  targetValues: string[],
  options?: { dataKey?: keyof T; childrenKey?: keyof T }
): T[] {
  const { dataKey = 'key', childrenKey = 'children' } = options || {}; // Default options
  const result: T[] = [];

  const traverse = (nodes: T[], targetValue: string) => {
    for (const node of nodes) {
      if (node[dataKey as keyof T] === targetValue) {
        result.push(node);
        return;
      }
      // Check if children exist and is an array.
      if (node[childrenKey as keyof T] && Array.isArray(node[childrenKey as keyof T])) {
        traverse(node[childrenKey as keyof T] as T[], targetValue); // Type assertion for children
      }
    }
  };

  targetValues.forEach(targetValue => traverse(data, targetValue));

  return result;
}
